import {Button, DialogActions, DialogContent, DialogTitle, Grid} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import {api} from "../../../../../api/API";
import moment from "moment";
import {timestampFormat} from "../Common";
import {Link} from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {EmailQueueItem} from "../EmailQueueItem";
import {useState} from "react";
import {JournalEntry} from "../../../../../api/ProjectJournal";

export function DeliveryProofPopup(props: {
    value: JournalEntry;
    onClose(): void;
}) {
    const [showEmail, setShowEmail] = useState<number | null>(null);

    if(props.value.type !== "delivery-complete") return null;
    const a = props.value.args;

    if(showEmail) {
        return <EmailQueueItem id={showEmail} onClose={() => setShowEmail(null)}/>
    }

    return (
        <Dialog2 open>
            <DialogTitle>{props.value.args.name}</DialogTitle>
            <DialogContent>

                <div>
                    <div>Signed By: {a.signedByName} ({(a.signedFiles || []).map(a => <a target="_blank" href={api.files.downloadLink(a.File, "attachment")}>{a.Name}</a>)})</div>
                    <div>Timestamp: {moment(a.signedAt).format(timestampFormat)}</div>
                </div>
                <div style={{height: 16}}/>
                <Grid container spacing={1}>
                    <Grid item>
                        <Link target="_blank" to={`/logistics/packing/${props.value.delivery}`}>
                            <Button endIcon={<OpenInNewIcon />} variant="contained">View Delivery #{props.value.delivery}</Button>
                        </Link>
                    </Grid>
                    {a.route && <Grid item>
                        <Link target="_blank" to={`/logistics/route/${a.route}`}>
                            <Button endIcon={<OpenInNewIcon />} variant="contained">View Route #{a.route}</Button>
                        </Link>
                    </Grid>}
                    {props.value.emailQueue && <Grid item>
                        <Button variant="contained" onClick={() => {
                            setShowEmail(props.value.emailQueue);
                        }}>View Confirmation Email</Button>
                    </Grid>}
                </Grid>
                <div style={{height: 16}}/>

                <div style={{display: "flex", flexDirection: "row"}}>
                    {a.proofFiles?.map(a => (
                        <div>
                            <img alt="delivery proof" style={{maxWidth: 400, width: "100%", maxHeight: 400}}
                                 src={api.files.downloadLink(a.File, "inline")}/>
                            <div>
                                <Button onClick={() => {
                                    window.open(api.files.downloadLink(a.File, "attachment"), "_blank")
                                }}>Download</Button>
                            </div>
                        </div>
                    ))}
                </div>


            </DialogContent>
            <DialogActions>
                <div style={{flex: 1, fontSize: "0.8rem"}}>
                    <div>Created by: {props.value.createdByName}</div>
                    <div>Created at: {moment(props.value.createdAt).format("MMM D, YYYY")}</div>
                </div>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog2>
    )
}